import { useMantineTheme } from "@mantine/core";
import { ButtonSelectV2 } from "./ButtonSelectV2";
import { ButtonSelectV1 } from "./ButtonSelectV1";

export interface DataItem {
  value: string;
  label: string;
  description?: string;
}
export interface DataGroupItem {
  group: string;
  items: Array<DataItem> | string[];
}
export type Data = string[] | DataItem[] | DataGroupItem[];

export interface ButtonsSelectProps {
  value?: string;
  numberOfColumns?: number;
  align?: "left" | "center" | "right";
  data?: Data;
  onChange: (value?: string) => void;
  error?: string;
  label?: string;
  allowDeselect?: boolean;
  onBlur?: () => void;
}

export const ButtonSelect = (props: ButtonsSelectProps) => {
  const theme = useMantineTheme();

  return theme.other.version === "v2" ? (
    <ButtonSelectV2 {...props} />
  ) : (
    <ButtonSelectV1 {...props} />
  );
};
